/**
 * Query keys for the Swoogo pages. Every key builds on the "swoogo" root, and
 * each record type builds its tables' keys on a list level and its record
 * pages' keys on a detail level, so an invalidation reaches exactly the
 * records that changed.
 */
export const swoogoKeys = {
  all: ["swoogo"],
  status: () => [...swoogoKeys.all, "status"],
  connection: () => [...swoogoKeys.all, "connection"],
  folders: () => [...swoogoKeys.all, "folders"],
};

export const swoogoEventKeys = {
  all: [...swoogoKeys.all, "events"],
  lists: () => [...swoogoEventKeys.all, "list"],
  list: lastSyncedAt => [...swoogoEventKeys.lists(), lastSyncedAt],
  details: () => [...swoogoEventKeys.all, "detail"],
  detail: id => [...swoogoEventKeys.details(), id],
};

export const swoogoSessionKeys = {
  all: [...swoogoKeys.all, "sessions"],
  lists: () => [...swoogoSessionKeys.all, "list"],
  list: lastSyncedAt => [...swoogoSessionKeys.lists(), lastSyncedAt],
  details: () => [...swoogoSessionKeys.all, "detail"],
  detail: id => [...swoogoSessionKeys.details(), id],
};

export const swoogoRegistrantKeys = {
  all: [...swoogoKeys.all, "registrants"],
  lists: () => [...swoogoRegistrantKeys.all, "list"],
  list: lastSyncedAt => [...swoogoRegistrantKeys.lists(), lastSyncedAt],
  details: () => [...swoogoRegistrantKeys.all, "detail"],
  detail: id => [...swoogoRegistrantKeys.details(), id],
};

export const swoogoAttendanceKeys = {
  all: [...swoogoKeys.all, "attendances"],
  lists: () => [...swoogoAttendanceKeys.all, "list"],
  list: lastSyncedAt => [...swoogoAttendanceKeys.lists(), lastSyncedAt],
};
